function formatTime(t) {
  var h = parseInt(t / 3600)
  h = h < 10 ? '0' + h : h
  var m = parseInt(t % 3600 / 60)
  m = m < 10 ? '0' + m : m
  var s = parseInt(t % 60)
  s = s < 10 ? '0' + s : s
  return h + ':' + m + ':' + s
}
// 根据时长获取  课时
function getAllKs(str) {
  var arrTime = str.split(':');
  var hours = arrTime[0] * 60;
  var allMint = hours + (Number(arrTime[1]));
  var allKs = parseFloat(allMint / 45, 2).toFixed(2);
  return allKs;
}
// 根据两个时间长度  算出百分比
function getPercent(bftime, alltime) {
  var timeArr1 = bftime.split(':');
  var time1 = timeArr1[0] * 60 * 60 + timeArr1[1] * 60 + parseInt(timeArr1[2]);

  var timeArr2 = alltime.split(':');
  var time2 = timeArr2[0] * 60 * 60 + timeArr2[1] * 60 + parseInt(timeArr2[2]);

  return parseInt((time1 / time2) * 100);
}

function format(str, newdate) {
  var today = new Date();
  if (newdate) {
    today = newdate;
  }
  var riqi = '';
  var year = today.getFullYear();
  var month = today.getMonth() + 1 > 9 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
  var date = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
  var hour = today.getHours() > 9 ? today.getHours() : '0' + today.getHours();
  var minutes = today.getMinutes() > 9 ? today.getMinutes() : '0' + today.getMinutes();
  var seconds = today.getSeconds() > 9 ? today.getSeconds() : '0' + today.getSeconds();
  str = str.replace(/YYYY/g, year);
  str = str.replace(/MM/g, month);
  str = str.replace(/DD/g, date);
  str = str.replace(/hh/g, hour);
  str = str.replace(/mm/g, minutes);
  str = str.replace(/ss/g, seconds);
  return str;
}
// 获取时间差
function getTimer(time1, time2) {
  var date2 = new Date(time2); //结束时间
  var date3 = date2.getTime() - new Date(time1).getTime(); //时间差的毫秒数
  var days = Math.floor(date3 / (24 * 3600 * 1000))

  var leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))
  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))
  //计算相差秒数
  var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000)


  var not0 = !!date3,
    d = days,
    h = hours,
    m = minutes,
    s = seconds;
  var absVal = Math.abs(days);
  return {
    days: d,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
}

function printWTHTML(totalPage) {
  // $("#pringNewData").html('<div style="margin-top:30%;">' + $("#"+id).html() + '</div>');
  $("#pringNewData").append('<div style="page-break-after:always"></div>');
  var bdhtml = window.document.body.innerHTML;
  totalPage = Number(totalPage);
  for (var i = 0; i < totalPage; i++) {
    $("#pringNewData").append($("#page" + (i + 1)).html());
    if ((i + 1) != totalPage) {
      $("#pringNewData").append('<div style="text-align: center; margin-top:10px;">———接下页———</div>');
    }
    $("#pringNewData").append('<div style="page-break-after:always"></div>');
  }
  // 获取当前页的html代码

  /*//设置打印开始区域
  //var startStr = '<!--startprint-->';
  // 设置打印结束区域
  //var endStr = '<!--endprint-->';
  //从标记里获取需要打印的页面
  var printHtml = bdhtml.substring(bdhtml.indexOf(startStr) + startStr.length, bdhtml.indexOf(endStr));*/
  //隐藏不必要的按钮和样式
  // 通过id获取需要打印的页面
  var printHtml = document.getElementById('page1').innerHTML;
  // 需要打印的页面
  window.document.body.innerHTML = printHtml;
  if (!!window.ActiveXObject || "ActiveXObject" in window) { //是否ie
    remove_ie_header_and_footer();
  }
  //调用打印
  document.getElementsByTagName('body')[0].style.zoom = 0.90;

  var imgs = $(printHtml).find('img').length; //是否含有图片
  $('.ant-pagination').remove(); //页码删除
  if (imgs) {
    document.querySelector('img').onload = function() {
      if (imgs > 5) {
        setTimeout(function() {
          window.print();
          $("#pringNewData").html("");
          window.close();
        }, 2000)
      } else {
        window.print();
        $("#pringNewData").html("");
        window.close();
      }
    }
  } else {
    window.print();
    $("#pringNewData").html("");
    window.close();
  }
}
// 阿里云上传
function createUploader(file) {
  var uploadInfo = new Object;
  uploadInfo.file = file;
  var videoid = sessionStorage.getItem("videoid");
  var uploader = new AliyunUpload.Vod({
    userId: "1362262321513414", //必填
    region: "cn-beijing", //上传到视频点播的地域，默认值为'cn-shanghai'，
    partSize: 1048576, //分片大小默认1 MB，不能小于100 KB（100*1024）
    parallel: 5, //并行上传分片个数，默认5
    retryCount: 3, //网络原因失败时，重新上传次数，默认为3
    retryDuration: 2, //网络原因失败时，重新上传间隔时间，默认为2秒
    //开始上传
    'onUploadstarted': function(uploadInfo) {
      // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
      // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
      // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
      // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
      // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
      // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
      if (!videoid) {
        $.ajax({
          url: '/safety/file/attachment/getuploadFileDB.htm?fileName=' + uploadInfo.file.name,
          type: 'get',
          dataType: 'json',
          headers: {
            "loginName": sessionStorage.getItem("loginName")
          },
          success: function(data) {
            var videoid = data.videoid;
            //放进缓存
            sessionStorage.setItem("videoid", data.videoid);
            sessionStorage.setItem('videoName', file.name);
            var uploadaddress = data.uploadaddress
            var uploadauth = data.uploadauth;
            uploader.setUploadAuthAndAddress(uploadInfo, uploadauth, uploadaddress, videoid)
          },
          error: function(data) {
            alert(data.responseText);
          }
        })
        console.log("onUploadStarted:" + uploadInfo.file.name)
      } else {
        $.ajax({
          url: '/safety/file/attachment/getRefreshUpload.htm?id=' + videoid,
          type: 'get',
          dataType: 'json',
          headers: {
            "loginName": sessionStorage.getItem("loginName")
          },
          success: function(data) {
            var videoid = data.videoid
            var uploadaddress = data.uploadaddress
            var uploadauth = data.uploadauth;
            //放进缓存
            sessionStorage.setItem("videoid", data.videoid);
            sessionStorage.setItem('videoName', file.name);
            uploader.setUploadAuthAndAddress(uploadInfo, uploadauth, uploadaddress, videoid)
          },
          error: function(data) {
            alert(data.responseText);
          }
        })
      }
    },
    //文件上传成功
    'onUploadSucceed': function(uploadInfo) {
      var name = file.name;
      $('#fileUploadAly').parent().find('.videoName').remove();
      $('#fileUploadAly').before('<div class="videoName">' + name + '</div>');
      $("#fileProgressBar").hide();
      //清除缓存
      // sessionStorage.removeItem("videoid");
    },
    //文件上传失败
    'onUploadFailed': function(uploadInfo, code, message) {
      console.log('文件上传失败!')
      //清除缓存
      // sessionStorage.removeItem("videoid");
    },
    //文件上传进度，单位：字节
    'onUploadProgress': function(uploadInfo, totalSize, loadedPercent) {
      console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" +
        Math.ceil(loadedPercent * 100) + "%")
      // var progressPercent = Math.ceil(loadedPercent * 100);
      $("#fileProgressBar").show();
    },
    //上传凭证或STS token超时
    'onUploadTokenExpired': function(uploadInfo) {
      $.ajax({
        url: '/safety/file/attachment/getRefreshUpload.htm?id=' + videoid,
        type: 'get',
        dataType: 'json',
        headers: {
          "loginName": sessionStorage.getItem("loginName")
        },
        success: function(data) {
          var uploadauth = data.uploadauth;
          uploader.resumeUploadWithAuth(uploadauth)
        },
        error: function(data) {
          alert(data.responseText);
        }
      })
    },
    //全部文件上传结束
    'onUploadEnd': function(uploadInfo) {
      console.log('文件上传完毕')
      //清除缓存
      // sessionStorage.removeItem("videoid");
    }
  });
  return uploader;
}

function getItype(axios, callback) {
  var options = [];
  if (localStorage.getItem('zywsItypeList')) {
    options = JSON.parse(localStorage.getItem('zywsItypeList'));
    callback(options)
  } else {
    axios.get('/system/datadict/tree.htm?supCode=ZXKT_producttype&state=1', {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      }
    }).then(res => {
      var data = res.data;
      options=data;
      data.map((item, i) => {
        getNextItype(item.uniqueCode, i, axios, ((child, j) => {
          options[j].children = child;
          if (j == data.length - 1) {
            localStorage.setItem('zywsItypeList',JSON.stringify(options));
            callback(options);
          }
        }));
      });
    });
  }
};

function getNextItype(supCode, i, axios, callback) {
  axios.get('/system/datadict/tree.htm?state=1&supCode=' + supCode, {
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    }
  }).then(res => {
    var data = res.data;
    if(supCode=='ZXKT_producttype_2'){
      localStorage.setItem('zyzcList', JSON.stringify(data));
    }
    if(supCode=='ZXKT_producttype_3'){
      localStorage.setItem('zyjnList', JSON.stringify(data));
    }
    callback(data,i)
  })
};
export {
  formatTime,
  getAllKs,
  getPercent,
  format,
  getTimer,
  printWTHTML,
  createUploader,
  getItype
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js